module.exports = __webpack_public_path__ + "img/brand-course-titel.5167f1df.png";